<template>
    <menu>

        <div class="menu-item" @click="isEventsOpen = !isEventsOpen">
            <div class="name">Події</div>
        </div>
        <div class="menu-item under-menu" v-if="isEventsOpen">
            <router-link to="/admin/events" tag="div" class="menu-item">
                <div class="name">Список</div>
            </router-link>
            <router-link to="/admin/events/add-event" tag="div" class="menu-item">
                <div class="name">Додати</div>
            </router-link>
        </div>

        <div class="menu-item" @click="isModeratorsOpen = !isModeratorsOpen">
            <div class="name">Модератори</div>
        </div>
        <div class="menu-item under-menu" v-if="isModeratorsOpen">
            <router-link to="/admin/moderators" tag="div" class="menu-item">
                <div class="name">Список</div>
            </router-link>
            <router-link to="/admin/moderators/add-moderator" tag="div" class="menu-item">
                <div class="name">Додати</div>
            </router-link>
        </div>

        <div class="menu-item" @click="isPatientsOpen = !isPatientsOpen">
            <div class="name">Пацієнти</div>
        </div>
        <div class="menu-item under-menu" v-if="isPatientsOpen">
            <router-link to="/admin/patients" tag="div" class="menu-item">
                <div class="name">Список</div>
            </router-link>
            <router-link to="/admin/patients/images" tag="div" class="menu-item">
                <div class="name">Зображення</div>
            </router-link>
        </div>
    </menu>
</template>

<script>
export default {
    data : () => ({
        isEventsOpen : false,
        isModeratorsOpen : false,
        isPatientsOpen : false
    })
}
</script>

<style lang="scss">
menu{
    width: 300px;
    height: 100vh;
    margin: 0;
    padding: 0;

    position: fixed;
    left: 0;
    z-index: 10;

    display: flex;
    flex-direction: column;
    align-items: flex-start;

    background: lightgray;

    .menu-item{
        width: calc(100% - 80px);
        padding: 20px 40px;
        border-bottom: 2px solid black;
        text-align: left;

        color: black;

        cursor: pointer;

        .name{
            text-transform: uppercase;
            font-weight: bold;
            letter-spacing: 2px;
        }
    }

    .menu-item:hover{
        background: grey;
    }

    .router-link-exact-active{
        color: #ffffff;
        background: rgb(85, 85, 85);
    }

    .under-menu{
        background: rgb(245, 245, 245);

        .menu-item{
            border-bottom: none;
            border-left: 1px solid grey;
            border-right: 1px solid grey;

            margin-top: 10px;
        }

        .router-link-exact-active{
            color: #ffffff;
            background: grey;   
        }
    }

    .under-menu:hover{
        background: rgb(245, 245, 245);
    }
}
</style>